/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Alert, Icon, Table } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import MapPropsContext from "../MapPropsContext";
import { getListByParameters } from "../../../api";
import ExportExcelButton from "../../../utils/export";
import { getApiUrl, makeTableSorterFn } from "../../../utils";
import { TI_MODAL_RESULT_CLOSE_BUTTON, USER_GBN } from "../../../Constants";
import AlignRightText from "./AlignRightText";

const WidgetStatisticsTable = ({
  visible,
  setTitleWithIndex,
  tabIndex,
  activeTabIndex,
  addDataByAdmin = false,
  pageSize = 10,
  getTitle,
  processor,
  columns,
  fetchUrl,
  horizontalScroll,
  verticalScroll,
  type,
  isSummaryInfo,
  isResourceUserStats = false,
}) => {
  const { geojsonPolygonsResponseList, widgetState, tableAjaxParams, currentDistrictCode, setCurrentDistrictCode } =
    useContext(MapPropsContext);

  const urlTemp = getApiUrl({ type: type });

  const [extraColumns, setExtraColumns] = useState([]);

  const [detailObjects, setDetailObjects] = useState();
  const [currentPageData, setCurrentPageData] = useState([]);
  const [error, setError] = useState();
  const [norow, setNorow] = useState(false);

  const [isDownloading, setIsDownloading] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(true);

  const polygonLayer = geojsonPolygonsResponseList;

  const [clsCodeStatsList, setClsCodeStatsList] = useState([]);
  const [serviceCodeStatsList, setServiceCodeStatsList] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [searchStartYear, setSearchStartYear] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [searchEndYear, setSearchEndYear] = useState("");

  // 컬럼 정렬 기준값을 담아둘 상탯값을 정의하고, 이를 각 컬럼의 sortOrder에 반영합니다.
  const [sortedInfo, setSortedInfo] = useState({});

  const newColumns = useMemo(() => {
    let tmpColumns = columns;
    if (extraColumns && extraColumns.length > 0) {
      tmpColumns = tmpColumns.concat(extraColumns);
    }
    const processedColumns = tmpColumns.map((column) => {
      const { dataIndex } = column;
      const { columnKey, order } = sortedInfo || {};
      const sortOrder = columnKey === dataIndex && order;
      return {
        ...column,
        ...(typeof columns !== "function" ? columns : columns(currentPageData)),
        // ...extraColumns,
        sortOrder,
      };
    });
    return processedColumns;
  }, [columns, sortedInfo, extraColumns]);

  useEffect(() => {
    setIsTableLoading(true); // 초기화
    if (detailObjects && detailObjects.length > 0 && !error) setIsTableLoading(false);
  }, [detailObjects]);

  useEffect(() => {
    if (widgetState) {
      setServiceCodeStatsList(widgetState["service_code_stats_list"] || []);
      setClsCodeStatsList(widgetState["cls_code_stats_list"] || []);
    }
  }, [widgetState]);

  useEffect(() => {
    if (visible && urlTemp) {
      setDetailObjects(undefined); // 초기화
      const title = getTitle(polygonLayer);
      setTitleWithIndex(title, tabIndex);

      setError(null);
      setNorow(false);

      let tmpSearchStartYear = "";
      let tmpSearchEndYear = "";
      let tmpCurrentDistrictCode = "";

      if (
        tableAjaxParams &&
        Object.keys(tableAjaxParams).length !== 0 &&
        JSON.stringify(tableAjaxParams) !== JSON.stringify({})
      ) {
        setSearchStartYear(tableAjaxParams["searchStart"], "");
        setSearchEndYear(tableAjaxParams["searchEnd"]);
        setCurrentDistrictCode(tableAjaxParams["sidoCode"]);

        tmpSearchStartYear = tableAjaxParams["searchStart"] || "";
        tmpSearchEndYear = tableAjaxParams["searchEnd"];
        tmpCurrentDistrictCode = tableAjaxParams["sidoCode"] || "";
      } else if (window.searchStart && window.searchEnd) {
        setSearchStartYear(window.searchStart);
        setSearchEndYear(window.searchEnd);

        tmpSearchStartYear = window.searchStart;
        tmpSearchEndYear = window.searchEnd;
        tmpCurrentDistrictCode = currentDistrictCode;
      } else {
        setSearchStartYear("200912");
        setSearchEndYear("201812");

        tmpSearchStartYear = "200912";
        tmpSearchEndYear = "201812";
        tmpCurrentDistrictCode = currentDistrictCode;
      }

      if (!currentDistrictCode) {
        setCurrentDistrictCode("");
        tmpCurrentDistrictCode = "";
      }

      const params = {
        relUrl: urlTemp,
        currentDistrictCode:
          tmpCurrentDistrictCode.length > 2 ? tmpCurrentDistrictCode.substr(0, 2) : tmpCurrentDistrictCode,
        clsCodeStatsList,
        serviceCodeStatsList,
        searchStartYear: tmpSearchStartYear,
        searchEndYear: tmpSearchEndYear,
      };
      getListByParameters(params)
        .then(({ data }) => {
          const objectList = data.data;
          if (processor) {
            const [columns, rowList] = processor(objectList);
            setExtraColumns(columns);
            setDetailObjects(rowList.map((row, index) => ({ index: index + 1, ...row })));
          } else {
            setExtraColumns([]);
            if (isSummaryInfo) {
              setDetailObjects(
                objectList
                  .filter(({ usage_nm_d, type_name }) => usage_nm_d === "전체" || type_name === "전체")
                  .map((row, index) => ({ index: index + 1, ...row }))
              );
            } else {
              setDetailObjects(objectList.map((row, index) => ({ index: index + 1, ...row })));
            }
          }
          if (objectList.length === 0) {
            setNorow(true);
          }
        })
        .catch((e) => setError(e));
    } else if (!visible) {
      setDetailObjects(undefined);
      setSortedInfo(null);
    }
  }, [visible, currentDistrictCode, clsCodeStatsList, serviceCodeStatsList, fetchUrl, tableAjaxParams]);

  const downloadXlsx = useCallback(() => {
    if (visible && fetchUrl) {
      setError(null);
      setIsDownloading(false);
    }
  }, [detailObjects]);

  // detailObjects 변경 시에 1페이지 데이터를 currentPageData에 반영
  useEffect(() => {
    // const pageSize = 10;  // FIXME: Table로부터 값을 획득하기
    setCurrentPageData((detailObjects || []).slice(0, pageSize));
  }, [detailObjects]);

  const excelData = () => {
    return (
      detailObjects &&
      detailObjects.map((row, index) => ({
        // index: index + 1, style:{fill: {patternType: "solid", fgColor: {rgb: "FF00FF00"}}}, ...row
        index: index + 1,
        style: {
          fill: { patternType: "solid", fgColor: { rgb: "FF00FF00" } },
          numFmt: "0.00%",
          font: { sz: "20" },
        },
        ...row,
      }))
    );
  };

  const makeColumnsByResourceUserStats = () => {
    return [
      {
        title: "순번",
        dataIndex: "index",
        key: "index",
        width: 60,
        fixed: "left",
      },
      { title: "구군", dataIndex: "gubun_nm", key: "gubun_nm", width: 120 },
      {
        title: "시가화지수 수치",
        dataIndex: "시가화 지수수치",
        key: "시가화 지수수치",
      },
      {
        title: "시가화지수 등급",
        dataIndex: "시가화 지수등급",
        key: "시가화 지수등급",
      },
      {
        title: "인구비율 수치",
        dataIndex: "인구비율수치",
        key: "인구비율수치",
      },
      {
        title: "인구비율 등급",
        dataIndex: "인구비율등급",
        key: "인구비율등급",
      },
      {
        title: "재정자주도 수치",
        dataIndex: "재정자주도수치",
        key: "재정자주도수치",
      },
      {
        title: "재정자주도 등급",
        dataIndex: "재정자주도등급",
        key: "재정자주도등급",
      },
      {
        title: "무선국 자격증 보유자 수 수치",
        dataIndex: "무선국 자격증 보유자 수수치",
        key: "무선국 자격증 보유자 수수치",
      },
      {
        title: "무선국 자격증 보유자 수 등급",
        dataIndex: "무선국 자격증 보유자 수등급",
        key: "무선국 자격증 보유자 수등급",
      },
      {
        title: "무선국 밀도 수치",
        dataIndex: "무선국 밀도수치",
        key: "무선국 밀도수치",
      },
      {
        title: "무선국 밀도 등급",
        dataIndex: "무선국 밀도등급",
        key: "무선국 밀도등급",
      },
      {
        title: "전파Tech지수 수치",
        dataIndex: "전파Tech지수수치",
        key: "전파Tech지수수치",
      },
      {
        title: "전파Tech지수 등급",
        dataIndex: "전파Tech지수등급",
        key: "전파Tech지수등급",
      },
    ];
  };

  const makeColumnsByFusionResourceAdmin = () => {
    return [
      {
        title: "순번",
        dataIndex: "index",
        key: "index",
        width: 60,
        fixed: "left",
      },
      {
        title: "구군",
        dataIndex: "data_field",
        key: "data_field",
        sorter: makeTableSorterFn("data_field"),
      },
      {
        title: "2G-SK",
        dataIndex: "data_2g_sk",
        key: "data_2g_sk",
        render: (value) => AlignRightText({ text: value.toFixed(1), numberComma: true }),
        sorter: makeTableSorterFn("data_2g_sk"),
      },
      {
        title: "2G-KT",
        dataIndex: "data_2g_kt",
        key: "data_2g_kt",
        render: (value) => AlignRightText({ text: value.toFixed(1), numberComma: true }),
        sorter: makeTableSorterFn("data_2g_kt"),
      },
      {
        title: "2G-LG",
        dataIndex: "data_2g_lg",
        key: "data_2g_lg",
        render: (value) => AlignRightText({ text: value.toFixed(1), numberComma: true }),
        sorter: makeTableSorterFn("data_2g_lg"),
      },
      {
        title: "3G-SK",
        dataIndex: "data_3g_sk",
        key: "data_3g_sk",
        render: (value) => AlignRightText({ text: value.toFixed(1), numberComma: true }),
        sorter: makeTableSorterFn("data_3g_sk"),
      },
      {
        title: "3G-KT",
        dataIndex: "data_3g_kt",
        key: "data_3g_kt",
        render: (value) => AlignRightText({ text: value.toFixed(1), numberComma: true }),
        sorter: makeTableSorterFn("data_3g_kt"),
      },
      {
        title: "3G-LG",
        dataIndex: "data_3g_lg",
        key: "data_3g_lg",
        render: (value) => AlignRightText({ text: value.toFixed(1), numberComma: true }),
        sorter: makeTableSorterFn("data_3g_lg"),
      },
      {
        title: "LTE-SK",
        dataIndex: "data_lte_sk",
        key: "data_lte_sk",
        render: (value) => AlignRightText({ text: value.toFixed(1), numberComma: true }),
        sorter: makeTableSorterFn("data_lte_sk"),
      },
      {
        title: "LTE-KT",
        dataIndex: "data_lte_kt",
        key: "data_lte_kt",
        render: (value) => AlignRightText({ text: value.toFixed(1), numberComma: true }),
        sorter: makeTableSorterFn("data_lte_kt"),
      },
      {
        title: "LTE-LG",
        dataIndex: "data_lte_lg",
        key: "data_lte_lg",
        render: (value) => AlignRightText({ text: value.toFixed(1), numberComma: true }),
        sorter: makeTableSorterFn("data_lte_lg"),
      },

      {
        title: "5G-SK",
        dataIndex: "data_5g_sk",
        key: "data_5g_sk",
        render: (value) => AlignRightText({ text: value.toFixed(1), numberComma: true }),
        sorter: makeTableSorterFn("data_5g_sk"),
      },
      {
        title: "5G-KT",
        dataIndex: "data_5g_kt",
        key: "data_5g_kt",
        render: (value) => AlignRightText({ text: value.toFixed(1), numberComma: true }),
        sorter: makeTableSorterFn("data_5g_kt"),
      },
      {
        title: "5G-LG",
        dataIndex: "data_5g_lg",
        key: "data_5g_lg",
        render: (value) => AlignRightText({ text: value.toFixed(1), numberComma: true }),
        sorter: makeTableSorterFn("data_5g_lg"),
      },

      {
        title: "합계",
        dataIndex: "data_sum",
        key: "data_sum",
        render: (value) => AlignRightText({ text: value.toFixed(1), numberComma: true }),
        sorter: makeTableSorterFn("data_sum"),
      },
    ];
  };

  return (
    <div>
      {!fetchUrl && <Alert type="error" message="fetchUrl 미등록" />}
      {fetchUrl && (
        <>
          <div
            style={{
              // position: "absolute",
              display: "flex",
              justifyContent: "end",
              // top: 10,
              // right: 82,
              // zIndex: -1,
            }}
            hidden={tabIndex !== activeTabIndex}
          >
            <ExportExcelButton
              tabIndex={TI_MODAL_RESULT_CLOSE_BUTTON + 1}
              onClick={downloadXlsx}
              style={{ marginRight: 2, marginTop: 8, marginBottom: 8 }}
              type="primary"
              disabled={!fetchUrl || isDownloading}
              filename={getTitle()}
              data={excelData()}
              columns={
                addDataByAdmin && USER_GBN && USER_GBN === "2"
                  ? makeColumnsByFusionResourceAdmin()
                  : isResourceUserStats
                  ? makeColumnsByResourceUserStats()
                  : [...(typeof columns !== "function" ? columns : columns(currentPageData)), ...extraColumns]
              }
            >
              {isDownloading && <Icon type="loading" />}
              {!isDownloading && <FontAwesomeIcon icon={faFileExcel} />}
              <span style={{ marginLeft: 8 }}>엑셀 내보내기</span>
            </ExportExcelButton>
          </div>
          <div style={STYLE_CONTENT}>
            {norow && <Alert message={"조회된 데이터가 없습니다."} type={"warning"} />}
            {error && <Alert message={"데이터 로딩에 실패했습니다. 잠시 후 다시 시도해주세요."} type={"error"} />}
            {!error && (
              <Table
                dataSource={detailObjects}
                columns={
                  newColumns
                  // [
                  // ...(typeof columns !== 'function' ? columns : columns(currentPageData)),
                  // ...extraColumns,
                  // ]
                }
                size={"small"}
                rowKey={"index"}
                bordered={true}
                loading={isTableLoading} // detailObjects가 undefined 이고, 에러가 없을 때 또는 detailObjects가 빈Array이 일때 로딩 표시됨
                ellipsis={true}
                // scroll={{ x: horizontalScroll || 1200 }}
                tableLayout={"fixed"}
                onChange={({ current, pageSize }, filter, sorter, { currentDataSource }) => {
                  console.log(sorter);
                  const startIndex = (current - 1) * pageSize; // current : 1부터 시작
                  const endIndex = current * pageSize;
                  setCurrentPageData(currentDataSource.slice(startIndex, endIndex));

                  // 테이블의 변경정보를 관련 상탯값에 반영합니다.
                  setSortedInfo(sorter);
                }}
                pagination={{ pageSize: pageSize }}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

const STYLE_CONTENT = {
  height: "100%",
  marginBottom: "30px",
};

const STYLE_SUBMIT = {
  // position: "absolute",
  // display: 'flex',
  top: 10,
  right: 62,
};

export default WidgetStatisticsTable;
